import AUTH_CONFIG from 'utils/authConfig';
import { parseJwt } from 'utils/functions';

class AuthStore {
  constructor() {
    if (!AuthStore.instance) {
      this._data = localStorage;
      AuthStore.instance = this;
    }

    return AuthStore.instance;
  }

  set accessToken(value) {
    console.log('value', value);
    const tokenObj = parseJwt(value);
    const { nbf: auth_time = 0, exp = 0 } = tokenObj;
    this._data.setItem(`authtime-${AUTH_CONFIG.storageBasePath}`, auth_time);
    this._data.setItem(`expireat-${AUTH_CONFIG.storageBasePath}`, exp);
    this._data.setItem(`accessToken-${AUTH_CONFIG.storageBasePath}`, value);
  }

  get expireat() {
    return this._data.getItem(`expireat-${AUTH_CONFIG.storageBasePath}`);
  }

  get accessToken() {
    return this._data.getItem(`accessToken-${AUTH_CONFIG.storageBasePath}`);
  }

  set refreshToken(value) {
    this._data.setItem(`refreshToken-${AUTH_CONFIG.storageBasePath}`, value);
  }

  get refreshToken() {
    return this._data.getItem(`refreshToken-${AUTH_CONFIG.storageBasePath}`);
  }

  deleteRefreshToken() {
    this._data.removeItem(`refreshToken-${AUTH_CONFIG.storageBasePath}`);
  }

  set firstName(value) {
    this._data.setItem(`firstName-${AUTH_CONFIG.storageBasePath}`, value);
  }

  get firstName() {
    return this._data.getItem(`firstName-${AUTH_CONFIG.storageBasePath}`);
  }

  set emailId(value) {
    this._data.setItem(`emailId-${AUTH_CONFIG.storageBasePath}`, value);
  }

  get emailId() {
    return this._data.getItem(`emailId-${AUTH_CONFIG.storageBasePath}`);
  }

  deleteFirstName() {
    this._data.removeItem(`firstName-${AUTH_CONFIG.storageBasePath}`);
  }

  set lastName(value) {
    this._data.setItem(`lastName-${AUTH_CONFIG.storageBasePath}`, value);
  }

  get lastName() {
    return this._data.getItem(`lastName-${AUTH_CONFIG.storageBasePath}`);
  }

  deleteLastName() {
    this._data.removeItem(`lastName-${AUTH_CONFIG.storageBasePath}`);
  }

  set role(value) {
    this._data.setItem(`role-${AUTH_CONFIG.storageBasePath}`, value);
  }

  get role() {
    return this._data.getItem(`role-${AUTH_CONFIG.storageBasePath}`);
  }

  deleteRole() {
    this._data.removeItem(`role-${AUTH_CONFIG.storageBasePath}`);
  }

  emptyStore() {
    this._data.removeItem(`accessToken-${AUTH_CONFIG.storageBasePath}`);
    this._data.removeItem(`refreshToken-${AUTH_CONFIG.storageBasePath}`);
    this._data.removeItem(`firstName-${AUTH_CONFIG.storageBasePath}`);
    this._data.removeItem(`lastName-${AUTH_CONFIG.storageBasePath}`);
    this._data.removeItem(`role-${AUTH_CONFIG.storageBasePath}`);
    this._data.removeItem(`expireat-${AUTH_CONFIG.storageBasePath}`);
    this._data.removeItem(`authtime-${AUTH_CONFIG.storageBasePath}`);
  }
}

const instance = new AuthStore();
Object.freeze(instance);

export default instance;
